<template>
    <v-overlay v-if="show">
        <v-card light width="85vw" max-width="85vw" height="75vh" max-height="75vh" style="overflow-y:auto" class="elevation-1">
            <v-card-title style="position:sticky; top:0; background-color:white; z-index:1;">
                <v-row>
                    <v-col class="py-0">업체추가</v-col>
                    <v-col cols="auto" class="py-0">
                        <v-btn @click="hideOverlay" text small class="px-0"><v-icon>mdi-close</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col class="my-0 py-0">
                        <v-data-table :headers="interiorsHeaders" :items="interiorsToRequest" :search="searchValue" disable-sort>
                            <template v-slot:top>
                                <v-text-field v-model="searchValue" label="검색하기" class="my-0 mx-4 py-0" />
                            </template>
                            <template v-slot:item.distance="{ item }"> {{ item.distance ? Math.round(item.distance / 1000) + " km" : "-" }} </template>
                            <template v-slot:item.phone="{ item }"> {{ item.phone.phoneNumberFormat() }} </template>
                            <!-- <template v-slot:item.address="{ item }"> {{ item.address1 }}, {{ item.address2 }} </template> -->
                            <template v-slot:item.interiorCareer="{ item }">
                                {{ item.meta.interiorCareerYear > 0 ? `${item.meta.interiorCareerYear}년 ` : "" }}{{ item.meta.interiorCareerMonth > 0 ? `${item.meta.interiorCareerMonth}월` : "" }}
                            </template>
                            <template v-slot:item.reassurance="{ item }"> {{ item.scope.includes("reassurance") ? "안심" : "일반" }} </template>
                            <template v-slot:item.meta.interiorAreas="{ item }">
                                {{ item.meta.interiorAreas.join(", ") }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn small color="primary" @click="$emit('saveInteriors', item)">추가하기</v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-overlay>
</template>
<script>
import api from "@/api";
export default {
    props: {
        inquiry: {
            type: Object,
            default: {
                _id: undefined,
                interiors: [],
            },
        },
    },
    data() {
        return {
            show: false,
            interiors: [],
            interiorsHeaders: [
                { text: "업체명", width: 160, value: "meta.companyName" },
                { text: "거리", width: 80, value: "distance" }, // todo
                { text: "전화번호", width: 140, value: "phone" },
                { text: "주소", width: 240, value: "address1" },
                { text: "경력", width: 100, value: "interiorCareer" },
                { text: "분류", width: 120, value: "meta.interiorType" },
                { text: "안심파트너", width: 100, value: "reassurance" },
                { text: "진행건수", width: 100, value: "selectedNumber" },
                { text: "평점", width: 80, value: "meta.interiorAverage" },
                { text: "시공지역", width: 240, value: "meta.interiorAreas" },
                { text: "Actions", width: 120, value: "actions" },
            ],
            searchValue: "",
        };
    },
    methods: {
        showOverlay() {
            this.search();
            if (!this.show) this.show = true;
        },
        hideOverlay() {
            if (this.show) this.show = false;
        },
        async search() {
            try {
                const { users: interiors } = await api.console.users.getUsers({
                    params: { scope: "interior", geolocation: this.inquiry.geolocation, withSelectedNumber: true },
                });

                this.interiors = interiors;
            } catch (error) {
                this.handleError(error);
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
    computed: {
        interiorsToRequest() {
            return this.inquiry.interiors.reduce((array, next) => array.filter(({ _id }) => _id !== next._id), this.interiors);
        },
    },
};
</script>
